import React from "react";
import {
  Dialog,
  DialogContent,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme
} from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import ChatIcon from "@mui/icons-material/Chat";
import useStyles from "../../styles";
import { Marketing } from "../../../marketing";

interface CommunicationDialog {
  open: boolean;
  onClose: () => void;
}

const CommunicationDialog: React.FC<CommunicationDialog> = ({
  open,
  onClose
}) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmallDown = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <>
      <Dialog
        fullWidth
        fullScreen={isSmallDown}
        maxWidth="md"
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <div className={classes.dialogHeader}>
          <ChatIcon className={classes.receiptIcon} />
          <Typography
            variant="button"
            component="span"
            style={{ fontWeight: 500, marginRight: 16 }}
          >
            Communication
          </Typography>

          <IconButton
            aria-label="close"
            className={classes.closeButton}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </div>
        <DialogContent dividers>
          <Marketing />
        </DialogContent>
      </Dialog>
    </>
  );
};

export default CommunicationDialog;
